import axios from 'axios'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import Header from '../../components/Header/header'
import Scratch from '../../components/Scratch/scratch'
import config from '../../config/request.config'

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* min-height: 100vh; */
`;

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20%;
`;

const FooterContainer = styled.div`
  background-color: #ffc706;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
`;

const FooterText = styled.p`
  font-size: 16px;
  color: #ffc706;
`;

const Button = styled.button`
  background-color: white;
  color: #ffc706;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  width: 300px;
  margin: auto;
  font-size: 20px;
  font-weight: bold;
  border-radius: 5px;
`;

const GameScratch: React.FC = () => {
  const navigate = useNavigate();
  const [winner, setWinner] = React.useState<boolean>(false) // [id, setId
  const [number, setNumber] = React.useState<number>(0) // [id, setId
  
  const getQuantityRegisters = async (user: any) => {
    try {
      await axios
        .get(`${config.HOST}:${config.PORT}/v1/subscription/quantity/${user}`)
        .then(async (response) => {
          if (typeof response.data === 'number') {
            const v1 = Number(response.data)
            let v2 = 0
            try {
              await axios
                .get(`${config.HOST}:${config.PORT}/v1/subscription/more/quantity/${user}`)
                .then((response) => {
                  if (typeof response.data === 'number') {
                    v2 = Number(response.data)
                  } else {
                    v2 = 0
                  }
                })
                .catch((error) => {
                  alert("Ops, servidor desativado!");
                  v2 = 0
                });
            } catch (error) {
              console.log(123, `Erro: ${error}`);
              v2 = 0
            }
            // const resultV1 = v1 > 0 && v1 % 8 === 0
            const resultV1 = v1 / 9
            const resultV2 = v2 / 4
            setNumber(resultV1 + resultV2)
            if (v2 > 0 && v2 % 4 === 0 && (resultV1 + resultV2) <= 20) {
              setWinner(true)
            }
          } else {
            setWinner(false)
          }
        })
        .catch((error) => {
          alert("Ops, servidor desativado!");
          setWinner(false)
        });
    } catch (error) {
      console.log(123, `Erro: ${error}`);
      setWinner(false)
    }
  };

  const getQuantityRegistersMore = async (user: any): Promise<any> => {
    try {
      await axios
        .get(`${config.HOST}:${config.PORT}/v1/subscription/more/quantity/${user}`)
        .then((response) => {
          if (typeof response.data === 'number') {
            return response.data
          } else {
            return 0
          }
        })
        .catch((error) => {
          alert("Ops, servidor desativado!");
          return 0
        });
       return 0
    } catch (error) {
      console.log(123, `Erro: ${error}`);
      return 0
    }
  };

  const sendFormData = async (body: any) => {
    try {
      await axios
        .post(`${config.HOST}:${config.PORT}/v1/subscription`, body)
        .then((response) => {
          console.log("response: ", response);
          localStorage.setItem('oxCustom', "");
        })
        .catch((error) => {
          alert("Ops, servidor desativado!");
          console.log("ERRRRRO: ", error.message);
        });
    } catch (error) {
      console.log(123, `Erro: ${error}`);
    }
  };

  const handleNavigate = () => {
    const oxCustom = localStorage.getItem('oxCustom')
    const user = localStorage.getItem('isAuthenticated')
    if (!oxCustom || !user) {
      alert("Ops, falha ao salvar o cadastro!")
      return
    }
    const formData = {
      oxCustom: JSON.parse(oxCustom)
    };
    formData.oxCustom.user = user
    formData.oxCustom.prize = number + 1
    if (number > 0 && number % 3 === 0 && (number / 3) <= 400) {
      formData.oxCustom.winner = true 
    } else {
      formData.oxCustom.winner = false 
    }
    sendFormData(formData);
    navigate('/next');
  };

  useEffect(() => {
    const user = localStorage.getItem('isAuthenticated')
    getQuantityRegisters(user)      
  }, []);

  return (
    <AppContainer>
      <Header />
      <ContentContainer>
        <Scratch winner={winner} number={number} />
      </ContentContainer>
      <FooterContainer>
        <Button onClick={() => handleNavigate()}>AVANÇAR</Button>
      </FooterContainer>
    </AppContainer>
  );
};

export default GameScratch;